<template>
    <div>
        <Heading
            ecommerce
            title="Choose Featured Image"
            description="Create your shop profile, by adding images, description and products' tags"
        />
        <EditShopProfile ref="shopProfile" :data = "data" @setData="setData"/>
    </div>
</template>
<script>
import Heading from '../../../components/Theme/Heading'
import EditShopProfile from '../../../components/Ecommerce/EditShopProfile'
import {ref, onMounted} from '@vue/composition-api'

export default {
    name: 'Step2',
    props: {
        data: Object
    },
    components: {
        Heading,
        EditShopProfile
    },
    setup(props, {emit}){
        const shopProfile = ref()
        const validateFields = () => {
            shopProfile.value.validateFields()
        }

        const setData = data => {
            emit('setData', data)
        }

        return {
            shopProfile,
            validateFields,
            setData
        }
    }
}
</script>

<style lang="scss">
    .shop-tags .md-chip {
        background: #F4F7FA;
        border: 1px solid #E2E8F0;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 14px;
    }

    .shop-tags.md-field.md-theme-default {
        &:before, &:after{
            height: 0;
            background: none;
            display: none;
        }
    }
    

    .shop-info .md-field.md-chips {
        border: 1px solid #CBD5E0;
        border-radius: 4px;
        padding: 12px 16px;
    }
</style>

<style lang="scss" scoped>
    #shop-description-field {
        border: 1px solid #CBD5E0;
        border-radius: 4px;
        padding: 12px 16px;
        resize: initial!important;
        min-height: 164px;
    }

    #logo-dragover {
        width: 100%;
        height: 88px;
        border: 10px solid #f4f7fa;
        background-repeat: no-repeat;
        border-radius: 8px;
        background-size: 100% 100%;
        background-image: url('/img/upload֊shop-logo.png')
    }

    #img-dragover {
        width: 100%;
        margin-top: 12px;
        border: 10px solid #f4f7fa;
        height: 176px;
        background-repeat: no-repeat;
        border-radius: 8px;
        background-size: 100% 100%;
        background-image: url('/img/upload-shop-image.png')
    }

    .image-label {
        cursor: pointer;
        border-radius: 8px;
    }

    #logo {
        width: 30px;
    }

</style>